/**
 * FETCH_EVENT_SYNC_TASKS
 * Fetch the existing promoter's integration tasks
 *
 * @param { object } context - Store context (state, rootstate, getters, commit, dispatch)
 * @todo Handle @throws
 */
import { fixedEncodeURIComponent } from '@/utils/helpers'

export async function FETCH_EVENT_SYNC_TASKS({ state }, { promoterIntegrationOid, orderby, top, filter}) {
  if (!state.auth.account) { return null; }
  const { promoterOid } = state.auth.account;

  try {
    let url = `/promoter/${promoterOid}/integration/${promoterIntegrationOid}/task?$top=${top || 10}`;

    url += `&$filter=${filter}`;

    if (orderby) {
      let orderParam = `&$orderby=${fixedEncodeURIComponent(orderby)}`;
      url += orderParam;
    }

    const { data } = await this.$axios.sg.get(url);
    return data;
  } catch (error) {
    throw error;
  }
}
